module.exports = __webpack_public_path__ + "img/探测仪.3f019c0e.png";